import { SsMount } from 'src/js/dom/mount.js';
import { SsThreadItem } from 'src/js/dom/thread-item.js';

export class SsThread extends SsMount {
  addItems ( selector ) {
    this.items = Array.prototype.map.call(
      this.elm.querySelectorAll( selector ),
      item => new SsThreadItem( item )
    );
  }

  activateItems () {
    this.items.forEach( ( item ) => {
      item.accordionize();
    });
    return Promise.resolve();
  }
}
